import ExcelJs from "exceljs";

export default {
  newWorkbook() {
    return new ExcelJs.Workbook();
  },
  addNewSheet(workbook, name, rows = []) {
    const worksheet = workbook.addWorksheet(name);

    rows.forEach((row, index) => {
      if (index === 0) {
        worksheet.addRow(Object.keys(row));
      }
      worksheet.addRow(Object.values(row));
    });

    const font = {
      name: "Courier New",
      size: 12,
    };

    worksheet.columns.forEach((column) => {
      let maxLength = 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.font = font;
      column.width = maxLength * 1.2;
    });

    worksheet.getRow(1).font = {
      ...font,
      bold: true,
    };

    return worksheet;
  },
  async download(workbook, filename) {
    const excelBuffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}.xlsx`;
    link.click();

    URL.revokeObjectURL(link.href);
  },
};
